import { SurgicalOrderModel } from 'domain/entities/surgical-order-model'
import { ResponsibleSurgicalPendencyTypeEnum } from 'domain/entities/surgical-pendency'
import { HistoricModel } from 'domain/usecases/surgical-pendency/load-surgical-pendency'

export enum PendencyTypes {
  HELP_CARD = 'HELP_CARD',
  AUTHORIZED = 'AUTHORIZED',
  AUTHORIZED_COMMUNICATION = 'AUTHORIZED_COMMUNICATION',
  DOCTOR_COMMUNICATION = 'DOCTOR_COMMUNICATION'
}

export type SurgicalOrderProps = {
  surgicalOrder: SurgicalOrderModel
  surgicalOrderNoticeCard: any
  handleOpenRemakeModal: () => void
  handleOpenGuidesModal: () => void
  handleOpenEligibility: () => void
  handleOpenAuthorization: () => void
  handleOpenChangeStatus: () => void
}

export type PendencyHistoryType = {
  selectedPendencyHistory: {
    surgical_pendency_id: number
    status: string
    historic: HistoricModel[]
    surgical_pendency_parent_id: number
    surgical_pendency_order_id: number
    action: string
    createdAt: string
    surgical_order_id: number
    doctor_id: number
    responsible: string
    patient_id: number
    send_by: ResponsibleSurgicalPendencyTypeEnum
    type?: PendencyTypes
  }
  setIsLoading: any
  pendencyOrderId: any
  loadSurgicalPendency: any
  loadSurgicalPendencies: any
  timeLineItems: any
  cancelSolicitationVisible: boolean
  surgicalOrderNoticeCard: any
}

export type TimeLineTypes = {
  timeLineItems: [
    surgicalTimeLine: {
      action_type: string
      surgical_time_line_id: number
      surgical_order_id: number
      action: string
      surgical_pendency_id: number
      document_category: string
      persona: string
      created_at: string
    }
  ]
  loadSurgicalPendency: any
  setHistoryVisible: any
  setCancelSolicitationVisible: any
  setSelectedPendencyHistory: any
}

export type PendenciesType = {
  pendencies: {
    in_progress: {
      status: string
      surgical_pendency_id: number
      surgical_pendency_parent_id: number
      surgical_pendency_order_id: number
      createdAt: string
      responsible: string
      historic: HistoricModel[]
    }[]

    resolved: {
      surgical_pendency_id: number
      status: string
      surgical_pendency_parent_id: number
      surgical_pendency_order_id: number
      createdAt: string
      responsible: string
      historic: HistoricModel[]
    }[]

    pendent: {
      surgical_pendency_id: number
      status: string
      surgical_pendency_parent_id: number
      surgical_pendency_order_id: number
      createdAt: string
      responsible: string
      historic: HistoricModel[]
    }[]
  }
  setPendencyOrderId: any
  loadSurgicalPendency: any
}

export type HorizontalActionMenuProps = {
  activeItem: string
  onItemClick: (itemId: string) => void
  handleOpenRemakeModal: () => void
  handleOpenGuidesModal: () => void
  handleOpenFinishOrderEdit: () => void
  handleOpenActiveOrderReview: () => void
}

export type PendencyInfoType = {
  createdAt: string
  historic: HistoricModel[]
  responsible: string
  responsible_id?: number
  status?: string
  surgical_order_id?: number
  surgical_pendency_id: number
  surgical_pendency_order_id: number
  surgical_pendency_parent_id: number
  type?: PendencyTypes
}

export enum HealthInsuranceEnum {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE',
  ELIGIBLE_PENDING = 'ELIGIBLE_PENDING'
}

export enum TranslatedHealthInsuranceEnum {
  ELIGIBLE = 'Elegivel',
  INELIGIBLE = 'Não Elegível',
  ELIGIBLE_PENDING = 'Elegibilidade Pendente'
}

export enum statusEligibilityDocumentsEnum {
  APPROVED = 'approved',
  DISAPPROVED = 'disapproved',
  ANALYZING = 'analyzing'
}
